angular.module('storefront.account')
    .component('vcAccountReturn', {
        templateUrl: 'themes/assets/js/account/account-return.tpl.liquid',
        require: {
            accountManager: '^vcAccountManager',
        },
        controller: [
            'storefrontApp.mainContext',
            'confirmService',
            '$translate',
            '$scope',
            'loadingIndicatorService',
            function (
                mainContext,
                confirmService,
                $translate,
                $scope,
                loader,
            ) {
                const $ctrl = this;

                $ctrl.loader = loader;
            }],
    });
